import React from 'react'
import { useEffect } from 'react'
import groupAll from '../images/groupwhite.png'
import { gsap, ScrollTrigger } from "gsap/all"
import { useInView } from 'react-intersection-observer'
import { motion, useAnimation } from 'framer-motion'
gsap.registerPlugin(ScrollTrigger)


const Ethos = () => {

    const animation = useAnimation()
    const [ref, inView] = useInView({ threshold: 0.02 })

    useEffect(()=> {
        if(inView){
            animation.start("show")
        }
        if(!inView){
            animation.start("hidden")
        }
    }, [animation, inView])

    const container = {
        hidden: {
            opacity: 0,
            y: 100
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.4,
                duration: 1.2,
                ease: "easeOut"
            }
        }
    }

    return (
        <>
            <motion.div className="ethos-wrapper"
                ref={ref}
                animate={animation}
                initial="hidden"
                variants={container}
            >
                <motion.div className="content-ethos">
                    <img variants={container} className="ethos-img" src={groupAll} alt="logo"/>
                    <div className="title-ethos">
                        <h2 variants={container
                        } className="content-ethos__title-ethos"><span>ETHOS</span></h2>
                    </div>
                </motion.div>

                <div className="content-handmade">
                    <motion.div variants={container} className="content-handmade__text">
                        <p>Handmade, quality, limited run products. Get em while they’re hot!</p>
                        <p>Quality is everything, all products are made in batches specifically for you to assure the best quality!.</p>
                    </motion.div>
                </div>
                <div className="content-handmade">
                    <motion.div variants={container} className="content-handmade__text">
                        <p>Good vibes, good humor, nothing negative.</p>
                        <p>The world is crazy enough, our products are made to inspire and bring joy..</p>
                    </motion.div>
                </div>
                <div className="content-handmade handmade-last-one">
                    <motion.div variants={container} className="content-handmade__text">
                        <p>Inspired by personal stories.</p>
                        <p>Each product was inspired by a story or personal moment from a member of the team. Our goal is to make dope products!</p>
                    </motion.div>
                </div>
                
                <footer>
                    <h2>9FIFTY <br/> All Rights Reserved</h2>
                </footer>
            </motion.div>
        </>
    )
}

export default Ethos
